module.exports = __webpack_public_path__ + "static/media/writing-a-resume.a57ac6f2.jpg";